import axios from "axios";

export function kioskPublicationCategories(categorize = true) {
  return axios.get("/kiosk/publications", {
    params: {
      categorize
    }
  });
}

export function login(credentials) {
  return axios.post("/login", {
    ...credentials,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function ipLogin() {
  return axios.post("/login/ip", {
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function resettingRequestPassword(parameters) {
  return axios.post("/resetting/request", {
    ...parameters,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function resetPassword(parameters) {
  return axios.post("/resetting/reset", {
    ...parameters,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function checkQrCode(code) {
  return axios.get(`/kiosk/${process.env.REACT_APP_KIOSK_ID}/qrcode/${code}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: process.env.REACT_APP_API_SECRETE
    }
  });
}

export function getKiosk(apiKey = null) {
  const params = {};
  if (apiKey) {
    params.api_key = apiKey;
  }
  return axios.get("/kiosk/info", {
    params
  });
}

export function profile(apiKey = null) {
  const url = apiKey ? `/profile?api_key=${apiKey}` : "/profile";

  return axios.get(url);
}

export function contact(parameters) {
  return axios.post("/contact", {
    ...parameters,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function register(parameters) {
  return axios.post("/register?api_key=" + process.env.REACT_APP_API_SECRETE, {
    ...parameters,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function confirmRegistration(token) {
  return axios.post(`/register/confirm/${token}`, {
    token: token,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}

export function profileEdit(parameters) {
  return axios.post("/profile", {
    ...parameters,
    kiosk: process.env.REACT_APP_KIOSK_ID
  });
}
